import { PriceCashOnDeliveryMapper } from './PriceCashOnDeliveryMapper.js';
import { PriceDetailMapper } from './PriceDetailMapper.js';
import { PriceInsuranceMapper } from './PriceInsuranceMapper.js';
import { PriceVoucherMapper } from './PriceVoucherMapper.js';

/**
 * Plain object Packlink's API response representation.
 *
 */

class PriceProductsMapper {
  static createModelFromResponse(response) {
    if (!response) {
      return undefined;
    }
    return {
      porterage: PriceDetailMapper.createModelFromResponse(response.porterage),
      insurance: PriceInsuranceMapper.createModelFromResponse(response.insurance),
      voucher: PriceVoucherMapper.createModelFromResponse(response.voucher),
      proofOfDelivery: PriceDetailMapper.createModelFromResponse(response.proof_of_delivery),
      adultSignature: PriceDetailMapper.createModelFromResponse(response.adult_signature),
      additionalHandling: PriceDetailMapper.createModelFromResponse(response.additional_handling),
      managementFee: PriceDetailMapper.createModelFromResponse(response.management_fee),
      cashOnDelivery: PriceCashOnDeliveryMapper.createModelFromResponse(response.cash_on_delivery),
      priority: PriceDetailMapper.createModelFromResponse(response.priority)
    };
  }
}

export { PriceProductsMapper };
//# sourceMappingURL=PriceProductsMapper.js.map
